export const categories = {
  "categories.title": "Parcourir toutes les catégories",
  "categories.explore": "Explorez toutes les catégories",
  "categories.subtitle": "Découvrez les fournisseurs par secteur d'activité et trouvez exactement ce que vous cherchez",
  "categories.search_placeholder": "Rechercher une catégorie...",
  "categories.no_results": "Aucune catégorie trouvée",
  "categories.try_keywords": "Essayez avec d'autres mots-clés",
  "categories.stats_title": "Suji en chiffres",
  "categories.stats_subtitle": "La plateforme de référence pour les fournisseurs nigérians",
  "categories.verified_suppliers": "Fournisseurs vérifiés",
  "categories.product_categories": "Catégories de produits",
  "categories.states_covered": "États couverts",
  "categories.monthly_searches": "Recherches mensuelles",
  "categories.explore_category": "Explorer cette catégorie"
};

export default categories;
